import * as Yup from 'yup';
import { Shift } from '@models';

export function useValidationSchema() {
  return Yup.object<Shift>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
  }) as Yup.Schema<Shift>;
}
